<template>
	<v-card class="mx-auto" elevation="0">
		<v-card-title class="card-header">
			<v-row class="justify-end d-flex" dense>
				{{ $t('view') }} {{ $t('organization-mapping-pcc') }}
				<v-spacer />
				<!-- <v-icon v-if="getSelectedOrganization" @click="syncronizeDrawers" class="white-icon mr-1" size="22">
					mdi-pencil
				</v-icon> -->
				<v-icon @click="closeDrawer" class="white-icon" size="22">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text v-if="getSelectedOrganization">
			<v-card-text class="mt-1">
				<v-row dense class="pt-0">
					<v-col class="text-left pl-0" cols="12">
						<v-chip pill label color="primary2" class="font-weight-bold white--text font-size16">
							{{ getSelectedOrganization.pccOrganizationName }}
						</v-chip>
					</v-col>
					<v-col class="text-left pb-0 mb-0 pl-0" cols="12">
						<span>{{ getSelectedOrganization.pccCompanyMapping.organizationName }}</span>
					</v-col>
					<v-col class="text-left pt-0 mt-0 pl-0" cols="12">
						<span>{{ getSelectedOrganization.pccCompanyMapping.organizationAddress }}</span>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card elevation="3" class="pa-2 mx-3 text-left" height="200">
				<!-- prettier-ignore -->
				<span class="table-font-size" style="white-space: pre-wrap">{{ getSelectedOrganization.pccCompanyMapping.description }}</span>
			</v-card>
		</v-card-text>

		<v-card-text v-else-if="facility">
			<v-row dense class="pt-0">
				<v-col class="text-left pl-0" cols="12"> <strong>Facility Name:</strong> {{ facility.facilityName }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Country:</strong> {{ facility.country }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Address:</strong> {{ facility.addressLine1 }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Postal Code:</strong> {{ facility.postalCode }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Phone:</strong> {{ facility.phone }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>City:</strong> {{ facility.city }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>State:</strong> {{ facility.state }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Fax:</strong> {{ facility.fax }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Organization Name:</strong> {{ facility.orgName }} </v-col>

				<v-col class="text-left pl-0" cols="12">
					<strong>Facility Status:</strong> {{ facility.facilityStatus }}
				</v-col>

				<v-col class="text-left pl-0" cols="12">
					<strong>Billing Style Country:</strong> {{ facility.billingStyleCountry }}
				</v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Time Zone:</strong> {{ facility.timeZone }} </v-col>

				<v-col class="text-left pl-0" cols="12"> <strong>Active:</strong> {{ facility.active ? 'Yes' : 'No' }} </v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn
				block
				color="primary"
				v-if="!getSelectedOrganization && facility && facility.pccLocationsMapping?.length === 0"
				:disabled="showWizard"
				@click="createPCCMapping()">
				{{ $t('create') }}
			</v-btn>
		</v-card-actions>

		<OnboardingWizardDialog
			v-if="showWizard"
			:showDialog="showWizard"
			@closeWizardDialog="closeOnBoardingDialog"
			:dataProps="facility"
			@update:createdFacility="onCreatedFacility" />
	</v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { mailPurple, phonePurple, hospitalBlack } from '@/assets';
import OnboardingWizardDialog from '../dialogs/OnboardingWizardDialog.vue';
import { showSuccessAlert } from '../../utils/utilities';

export default {
	name: 'HospitalViewDrawer',
	components: { OnboardingWizardDialog },
	data: () => ({
		manual: true,
		automatic: false,
		mailPurple: mailPurple,
		phonePurple: phonePurple,
		hospitalBlack: hospitalBlack,
		relatedHospitals: [],
		showHospitals: false,
		facility: null,
		createdFacility: null,
		showWizard: false,
		onboardingWizardDialogData: null,
	}),
	async mounted () {
		this.facility = this.getPccSelectedLocation;
	},
	beforeDestroy () {
		this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
	},
	computed: {
		...mapGetters({
			getSelectedOrganization: 'mapping/getSelectedOrganization',
			getPccSelectedLocation: 'mapping/getPccSelectedLocation',
		}),
		...mapState({
			getPccMappingLocation: (state) => state.hospitals.getPccMappingLocation,
			allVerifiers: (state) => state.verifiers.allverifires,
		}),
		hospitalSpecializationTitle: function () {
			const fromVerifier = this.allVerifiers.filter(
				(v) =>
					v.rvDomain === 'HOSPITAL_SPECIALIZATION' && v.lowValue === this.selectedHospital.hospitalSpetializationId,
			);
			if (fromVerifier == null || fromVerifier.length === 0) {
				return '';
			} else {
				return fromVerifier[0].shortDescription;
			}
		},
	},
	methods: {
		...mapActions({
			getHospitalById: 'hospitals/getHospitalById',
			createPCCLocationMappingAndLocation: 'pcc/createPCCLocationMappingAndLocation',
			getPCCFacilityById: 'pcc/getPCCFacilityById',
			getMappedPccLocations: 'pcc/getMappedPccLocations',
		}),
		closeDrawer () {
			this.$store.commit('hospitals/SELECTED_HOSPITAL');
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
		},
		syncronizeDrawers () {
			// open drawer for edit
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: '/organizationMappingPcc',
			});
		},
		async createPCCMapping () {
			this.showWizard = true;
		},
		onCreatedFacility (facility) {
			this.createdFacility = facility;
		},
		async closeOnBoardingDialog (currentStepDialog = 0) {
			if (currentStepDialog === 0) {
				this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
			} else {
				const body = {
					pccLocationId: this.facility.facId,
					mappedHospitalId: this.createdFacility.id, // this.facility.pccCompaniesMapping[0].mappedCompanyId
					mappedOrganizationId: this.createdFacility.medicalInstitutionId,
					pccLocationName: this.facility.facilityName,
					residentCreationIsAutomatic: false, //
					userCreationIsAutomatic: false, //
					finalizeMeasurementAutomatically: true, //
					additionalData: '',
					description: this.facility.facilityName + ' at ' + this.createdFacility.address,
				};
				await this.createPCCLocationMappingAndLocation(body);
				this.facility = this.getPccSelectedLocation;
				await this.checkLocation();
				this.showWizard = false;
				this.getMappedPccLocations();
				if (this.getPccSelectedLocation.pccLocationsMapping?.length > 0) {
					showSuccessAlert(this.$t('mapping-created-successfully'));
					this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
				}
			}
		},
		async checkLocation () {
			const pccFacilityById = await this.getPCCFacilityById({
				pccOrgId: this.facility.orgUuid,
				facilitiesById: this.facility.facId,
			});
			await this.$store.commit('mapping/SELECTED_ORGANIZATION', null);
			await this.$store.commit('mapping/SELECTED_LOCATION', pccFacilityById);
			await this.$store.commit('mapping/SET_SELECTED_PCC_LOCATIONS', pccFacilityById);
		},
	},
};
</script>
